import TOKENS from '../theme/tokens.scss';

const overrides = {
	components: {
		MuiAutocomplete: {
			styleOverrides: {
				inputRoot: {
					'&[class*="MuiOutlinedInput-root"]': {
						'& .MuiAutocomplete-endAdornment': {
							right: '7px ',
						},
					},
				},
			},
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					fontWeight: TOKENS.fontWeightNormal,
					fontSize: TOKENS.textSizeSm,
					color: TOKENS.baseTextLightColor,
					backgroundColor: TOKENS.colorWhite,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					fontSize: TOKENS.texSizetMd,
					fontWeight: TOKENS.fontWeightRegular,
					borderRadius: TOKENS.borderRadiusSm,
					textTransform: TOKENS.textTransformCapitalize,
					'&.MuiButton-contained': {
						color: TOKENS.primaryTextLightColor,
						backgroundColor: TOKENS.primaryBgColor,
						border: `1px solid ${TOKENS.primaryBorderInteractiveColor}`,
					},
					'&.MuiButton-contained:hover': {
						backgroundColor: TOKENS.primaryBgHoverColor,
					},
					'&.MuiButton-outlined': {
						color: TOKENS.bodyTextColor,
						backgroundColor: TOKENS.surfaceWhiteColor,
						border: `1px solid ${TOKENS.baseBorderInteractiveColor}`,
					},
					'&.MuiButton-outlined:hover': {
						backgroundColor: TOKENS.baseBgLighthoverColor,
					},
					'&.MuiButton-text': {
						color: TOKENS.baseTextColor,
					},
					'&.MuiButton-text:hover': {
						backgroundColor: TOKENS.baseBgLighthoverColor,
					},
					'&.Mui-disabled': {
						opacity: TOKENS.disabledOpacity,
					},
				},
			},
		},
		MuiBottomNavigation: {
			styleOverrides: {
				root: {
					'& .MuiBottomNavigationAction-root': {
						color: TOKENS.primaryTextLightColor,
						backgroundColor: TOKENS.colorNavy80,
						fontSize: TOKENS.texSizetMd,
						fontWeight: TOKENS.fontWeightRegular,
					},
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {
					'&, & .MuiChip-colorPrimary': {
						color: TOKENS.primaryTextLightColor,
						backgroundColor: TOKENS.colorGray50,
					},
					'& .MuiChip-label': {
						fontWeight: '300',
						textOverflow: 'ellipsis',
						cursor: 'pointer',
						wordBreak: 'break-all',
						overflow: 'hidden',
						whiteSpace: 'nowrap',
					},
				},
			},
		},
		MuiCssBaseline: {
			'@global': {
				body: {
					backgroundColor: '#fff',
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					color: TOKENS.textMutedColor,
					fontSize: TOKENS.textSizeMd,
					borderRadius: TOKENS.borderRadiusSm,
					'&, & .MuiInputBase-input': {
						color: TOKENS.textMutedColor,
						fontSize: TOKENS.textSizeMd,
					},
				},
			},
		},
		MuiListItemButton: {
			styleOverrides: {
				root: {
					color: TOKENS.colorWhite,
					height: TOKENS.spacer10,
					'&, & .MuiListItemIcon-root': {
						color: TOKENS.colorWhite,
						fontSize: TOKENS.fontSize4,
						lineHeight: TOKENS.lineHeightXl,
					},
					'&.Mui-selected': {
						backgroundColor: TOKENS.colorNavy60,
					},
					'&.Mui-selected:hover': {
						backgroundColor: TOKENS.colorNavy70,
					},
					'&:hover': {
						backgroundColor: TOKENS.colorNavy70,
					},
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					color: TOKENS.textBodyColor,
					backgroundColor: TOKENS.surfaceWhiteColor,
					fontSize: TOKENS.textSizeMd,
					fontWeight: TOKENS.fontWeightRegular,
					'&.Mui-selected': {
						backgroundColor: TOKENS.primaryBgLightHoverColor,
					},
					'&.Mui-selected:hover': {
						backgroundColor: TOKENS.baseBgLighthoverColor,
					},
					'&:hover': {
						backgroundColor: TOKENS.baseBgLighthoverColor,
					},
					'&.MuiMenuItem-gutters': {
						padding: `${TOKENS.spacingSm} ${TOKENS.spacingMd}`,
					},
				},
			},
		},
		MuiPaper: {
			rounded: {
				borderRadius: 0,
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					color: TOKENS.textBodyColor,
					fontSize: TOKENS.textSizeMd,
					fontWeight: TOKENS.fontWeightRegular,
					marginRight: TOKENS.spacingSm,
					'&, & .MuiSvgIcon-root ': {
						marginLeft: '-.5rem',
					},
					'&.Mui-disabled': {
						opacity: TOKENS.disabledOpacity,
						'&, & .MuiSvgIcon-root ': {
							opacity: TOKENS.disabledOpacity,
						},
					},
				},
			},
		},
		MuiStack: {
			styleOverrides: {
				root: {
					color: TOKENS.linkColor,
					fontSize: TOKENS.textSizeMd,
					fontWeight: TOKENS.fontWeightRegular,
					'&, & .MuiSvgIcon-root ': {
						fill: TOKENS.linkColor,
					},
				},
			},
		},
		MuiStepper: {
			root: {
				'&.MuiPaper-root': {
					backgroundColor: 'transparent',
				},
			},
		},
		MuiTextField: {
			root: {
				'& input[type=text]::-ms-clear': {
					display: 'none',
				},
				'& input[type=password]::-ms-reveal': {
					display: 'none',
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					fontWeight: '300',
					lineHeight: '.85rem',
					padding: '.75rem',
				},
			},
		},
		MuiTypography: {
			gutterBottom: {
				marginBottom: '.75em',
			},
		},
	},
};

export default overrides;
